// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"e3f271bb","787":"43b2d7d5"}[chunkId] + ".chunk.js";
};